import React from 'react';
import { MotionImage } from '../ui/MotionPrimitives';

const AboutVision: React.FC = () => {
  return (
    <section className="w-full bg-white py-16 md:py-20">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 px-6 md:flex-row md:items-stretch md:gap-12 md:px-10">
        {/* Left: Big image */}
        <div className="w-full md:w-1/2">
          <div className="h-[300px] w-full overflow-hidden bg-gray-200 shadow-[0_22px_45px_rgba(15,23,42,0.18)] md:h-[400px]">
            <MotionImage
              src="/images/pics/khalifa 2.jpg"
              alt="Dubai skyline representing our global vision"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        {/* Right: Vision text */}
        <div className="w-full md:w-1/2">
          <h2 className="text-[28px] font-semibold text-black md:text-[32px]">Our Vision</h2>
          <p className="mt-3 text-sm text-black/60 md:text-[15px]">
            How we shape long-term value and meaningful experiences for every investor we partner with.
          </p>

          <div className="mt-6 space-y-5">
            <div>
              <h3 className="text-sm font-semibold text-black md:text-base">Creating Lifelong Partnerships</h3>
              <p className="mt-1 text-sm text-black/65 md:text-[14px]">
                Building trust-based relationships that align property investments with each client&apos;s evolving goals.
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-black md:text-base">Empowering Confident Decisions</h3>
              <p className="mt-1 text-sm text-black/65 md:text-[14px]">
                Translating market insight into clear guidance so every acquisition feels informed, strategic, and secure.
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-black md:text-base">Innovating For What&apos;s Next</h3>
              <p className="mt-1 text-sm text-black/65 md:text-[14px]">
                Anticipating new trends across the UAE and US to unlock resilient, future-focused real estate portfolios.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutVision;
